@switch (pageType) {
    @case ("supplier") {
        <packbo-supplier />
    }
    @case ("category") {
        <packbo-category />
    }
}
